// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0aee6970","977":"65441fe8"}[chunkId] + ".chunk.js";
};